export function IntakeCard({ done, onOpen }: { done: boolean; onOpen(): void }) {
  return (
    <section
      aria-label={done ? 'Your starting point' : 'Find your starting point'}
      class="flex flex-col sm:flex-row sm:items-center gap-4 rounded-2xl border border-[#c7d7f5] bg-[#f4f7fd] dark:bg-gray-800 dark:border-gray-700 px-5 py-4 mb-6"
    >
      <span class="hidden sm:inline-flex shrink-0 items-center justify-center w-10 h-10 rounded-full bg-[#003DA6] text-white">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-5 h-5"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="9" />
          <polygon points="15.5 8.5 13.5 13.5 8.5 15.5 10.5 10.5 15.5 8.5" />
        </svg>
      </span>
      <div class="flex flex-col gap-0.5 grow min-w-0">
        <h2 class="text-base font-semibold text-gray-900 dark:text-white">
          {done ? 'Your recordings' : 'Find your starting point'}
        </h2>
        <p class="text-sm text-gray-600 dark:text-gray-400">
          {done
            ? 'Picked for your business from your answers, plus the next live call.'
            : "3 questions, under a minute. We'll pick the recordings that fit your business right now."}
        </p>
      </div>
      <button
        type="button"
        class="self-start sm:self-auto shrink-0 min-h-10 px-5 rounded-full bg-[#003DA6] text-white text-sm font-semibold hover:bg-[#002d7a]"
        onClick={onOpen}
      >
        {done ? 'See them' : 'Start'}
      </button>
    </section>
  );
}
